import ModelBase from "./shared/model-base.js";

interface ModelAttributes {
  id: string | number;
  code?: string;
  name?: string;
  flag?: string;
  position?: number;
}

const OPTIONS = {
  i18nModelName: "country",
  columns: ["id", "code", "name", "flag", "position"],
  editColumns: {},
};

export default class Country extends ModelBase {
  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}
